// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.v-input input {\r\n    max-height: 18px;\n}\n.v-text-field input {\r\n    flex: 1 1 auto;\r\n    line-height: 20px;\r\n    padding: 8px 0;\r\n    max-width: 100%;\r\n    min-width: 0;\r\n    width: 100%;\n}\n.v-input input {\r\n    max-height: 32px;\r\n    min-height: 22px;\n}\r\n", ""]);
// Exports
module.exports = exports;
